import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button';

const buttonStyle = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '32px',
	width: '32px',
	border: 'none',
	borderRadius: '3px',
	background: 'transparent',
	cursor: 'pointer',
	'&:hover': {
		background: token('color.background.neutral.hovered'),
	},
});

const menuButtonIconColor = (isWhiteboardBetaEnabled: boolean) => {
	return isWhiteboardBetaEnabled ? token('color.icon.selected') : token('color.icon');
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MenuButton = styled(Button)<{
	isOpen: boolean;
	isWhiteboardBetaEnabled: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
}>(buttonStyle, {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&& svg': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: (props) =>
			props.isOpen
				? menuButtonIconColor(props.isWhiteboardBetaEnabled)
				: token('color.icon.subtle'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover svg': {
		color: token('color.icon'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DefaultLabel = styled.div({
	backgroundColor: token('color.background.neutral'),
	color: token('color.text'),
	borderRadius: '3px',
	font: token('font.body.small'),
	fontWeight: token('font.weight.bold'),
	padding: '1px 3px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoIcon = styled.div({
	height: '24px',
	width: '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FlexCenter = styled.div({
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexGrow: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MoreButtonContainer = styled.div({
	margin: `${token('space.100')} 0 ${token('space.100')} 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CurrentViewPill = styled.button({
	backgroundColor: token('color.background.accent.blue.subtlest'),
	color: token('color.text.brand'),
	margin: '4px 4px 4px 8px',
	borderRadius: '100px',
	padding: `${token('space.050')} ${token('space.100')}`,
	border: 'none',
	font: token('font.body'),
	display: 'flex',
	alignItems: 'center',
	outline: 'none',
	cursor: 'pointer',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	height: '180px',
	color: token('color.text'),
	padding: token('space.150'),
	margin: `${token('space.100')} 0 0 ${token('space.250')}`,
	font: token('font.body'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorIconWrapper = styled.div({
	marginBottom: token('space.100'),
});
